import { render, staticRenderFns } from "./NationalId.vue?vue&type=template&id=4a802284&"
import script from "./NationalId.vue?vue&type=script&lang=ts&"
export * from "./NationalId.vue?vue&type=script&lang=ts&"
import style0 from "./NationalId.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports